import { useLocation } from "react-router-dom";
import DrawerButton from "./DrawerButton";
import { Person } from "@mui/icons-material";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import useURLQuery from "../../../../../../Hooks/useURLQuery";

const UIText = {
  "es-CL": { label: "Usuarios" },
  "en-US": { label: "Users" },
};

const Users = () => {
  const { auth } = useUIBp();
  const location = useLocation().pathname.split("/")[2];
  const { group } = useURLQuery();
  const selected = location === "users";
  const navTo = `/dashboard/users?group=${group ? group : auth.group}`;
  const accentColor = selected ? "select.accent" : "primary.light";
  const icon = <Person {...{ sx: { color: accentColor } }} />;

  return <DrawerButton {...{ UIText, selected, navTo, icon, accentColor }} />;
};

export default Users;
